module.exports = __webpack_public_path__ + "static/media/fresh-white.8c4d0f4c.svg";